import { axiosRequest } from '../../api/utils';

const requestSupport = async (run, errCb) => {
  try {
    return await run();
  } catch (err) {
    const data = err?.response?.data ?? {};
    errCb?.({ ...data, status: err?.response?.status });
    return null;
  }
};

export const getSupportSummary = async ({ errCb } = {}) => {
  return requestSupport(async () => {
    const response = await axiosRequest.get('support/summary', { _auth: true });
    return response?.data ?? {};
  }, errCb);
};

export const getSupportThreads = async ({ status, organizationId, assigneeId, unreadOnly, q, updatedAfter, page = 0, count = 20, errCb } = {}) => {
  return requestSupport(async () => {
    const params = { page, count };
    if (status) params.status = status;
    if (organizationId) params.organization_id = organizationId;
    if (assigneeId) params.assignee_id = assigneeId;
    if (unreadOnly) params.unread_only = true;
    if (q) params.q = q;
    if (updatedAfter) params.updated_after = updatedAfter;

    const response = await axiosRequest.get('support/threads', { _auth: true, params });
    return response?.data ?? {};
  }, errCb);
};

export const getSupportThread = async ({ threadId, errCb }) => {
  return requestSupport(async () => {
    const response = await axiosRequest.get(`support/threads/${threadId}`, { _auth: true });
    return response?.data ?? {};
  }, errCb);
};

export const getSupportMessages = async ({ threadId, afterId, beforeId, count = 50, errCb }) => {
  return requestSupport(async () => {
    const params = { count };
    if (afterId) params.after_id = afterId;
    if (beforeId) params.before_id = beforeId;

    const response = await axiosRequest.get(`support/threads/${threadId}/messages`, { _auth: true, params });
    return response?.data ?? {};
  }, errCb);
};

export const sendSupportMessage = async ({ threadId, text, attachmentId, idempotencyKey, errCb }) => {
  return requestSupport(async () => {
    const body = {};
    if (text) body.text = text;
    if (attachmentId) body.attachment_id = attachmentId;

    const response = await axiosRequest.post(`support/threads/${threadId}/messages`, body, {
      _auth: true,
      headers: { 'Idempotency-Key': idempotencyKey },
    });
    return response?.data ?? {};
  }, errCb);
};

export const uploadSupportAttachment = async ({ file, onProgress, errCb }) => {
  return requestSupport(async () => {
    const form = new FormData();
    form.append('file', file, file.name);

    const response = await axiosRequest.post('support/attachments', form, {
      _auth: true,
      onUploadProgress: (event) => {
        if (!event.total) return;
        onProgress?.(Math.round((event.loaded / event.total) * 100));
      },
    });
    return response?.data ?? {};
  }, errCb);
};

export const patchSupportThread = async ({ threadId, body, errCb }) => {
  return requestSupport(async () => {
    const response = await axiosRequest.patch(`support/threads/${threadId}`, body, { _auth: true });
    return response?.data ?? {};
  }, errCb);
};

export const markSupportThreadRead = async ({ threadId, errCb }) => {
  return requestSupport(async () => {
    const response = await axiosRequest.post(`support/threads/${threadId}/read`, null, { _auth: true });
    return response?.data ?? {};
  }, errCb);
};
